// extracted by mini-css-extract-plugin
module.exports = {"option":"option_option__CDIEs","optionAmount":"option_optionAmount__CkAuw","optionInput":"option_optionInput__SqhN9","optionSelected":"option_optionSelected__vop_W"};